import { render, staticRenderFns } from "./Citation.vue?vue&type=template&id=4e32700d&scoped=true"
import script from "./Citation.vue?vue&type=script&lang=js"
export * from "./Citation.vue?vue&type=script&lang=js"
import style0 from "./Citation.vue?vue&type=style&index=0&id=4e32700d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32700d",
  null
  
)

export default component.exports